const SMSSubjectType = {
  APPOINTMENT_CONFIRMATION: 'appointment_confirmation',
  APPOINTMENT_DELIVERY_WINDOW_UPDATED: 'appointment_delivery_window_updated',
  APPOINTMENT_SCHEDULED: 'appointment_scheduled',
  DAY_AHEAD_REMINDER: 'day_ahead_reminder',
  DELAYED_ON_ROUTE: 'delayed_on_route',
  EMAIL_INVITE: 'email_invite',
  FEEDBACK_REQUEST: 'feedback_request',
  JOB_COMPLETED: 'job_completed',
  JOB_COMPLETED_NO_CHARGE: 'job_completed_no_charge',
  MANUAL_VERIFICATION: 'manual_verification',
  MESSAGE_FROM_TECHNICIAN: 'message_from_technician',
  NEXT_ON_LIST: 'next_on_list',
  OTHER: 'other',
  PAYMENT_REMINDER: 'payment_reminder',
  POWER_OF_ATTORNEY_REQUEST: 'power_of_attorney_request',
  RECALL_PROPOSAL: 'recall_proposal',
  RECALL_PROPOSAL_REMINDER: 'recall_proposal_reminder',
  RESCHEDULED: 'rescheduled',
  RETORQUE_WHEEL_BOLTS_REMINDER: 'retorque_wheel_bolts_reminder',
  TIRE_TREAD_LOWER_LEGAL_LIMIT: 'tire_tread_lower_legal_limit',
  UNABLE_TO_COMPLETE: 'unable_to_complete',
  WHEEL_PICKUP_DOCUMENT_SIGNING_REMINDER: 'wheel_pickup_document_signing_reminder',
  WHEEL_PICKUP_NOT_SIGNED_CANCELLED: 'wheel_pickup_not_signed_cancelled',
  new_route_assigned: 'new_route_assigned',
  route_not_started_reminder: 'route_not_started_reminder',
  route_confirmation_reminder: 'route_confirmation_reminder',
  TIRE_QUOTE_LOW_TREAD_MEASUREMENT: 'tire_quote_low_tread_measurement',
  TIRE_QUOTE: 'tire_quote',
  TIRE_QUOTE_PAID: 'tire_quote_paid',
  TIRE_QUOTE_ORDERED_AT_SUPPLIER: 'tire_quote_ordered_at_supplier',
  TIRE_QUOTE_INVENTORY_RECEIVED_AT_WAREHOUSE_CREATE_BOOKING_FLOW:
    'tire_quote_inventory_received_at_warehouse_create_booking_flow',
  TIRE_QUOTE_INVENTORY_RECEIVED_AT_WAREHOUSE_TIRE_HOTEL_CHANGE:
    'tire_quote_inventory_received_at_warehouse_tire_hotel_change',
  TIRES_MOUNTED_ON_WHEELS_AT_STORAGE_FACILITY: 'tires_mounted_on_wheels_at_storage_facility',
  TIRES_RECEIVED_AT_STORAGE_FACILITY_NO_TIRE_HOTEL: 'tires_received_at_storage_facility_no_tire_hotel',
  TIRE_QUOTE_TIRE_RECEIVED_AT_STORAGE_FACILITY: 'tire_quote_tire_received_at_storage_facility',
  TIRE_QUOTE_NOT_SELECTED_REMINDER: 'tire_quote_not_selected_reminder',
  ad_hoc: 'ad_hoc'
} as const;

type SMSSubjectTypeValue = (typeof SMSSubjectType)[keyof typeof SMSSubjectType];

export const SMSSubjectTypeLabels: Record<SMSSubjectTypeValue, string> = {
  [SMSSubjectType.APPOINTMENT_CONFIRMATION]: 'Appointment confirmation',
  [SMSSubjectType.APPOINTMENT_DELIVERY_WINDOW_UPDATED]: 'Appointment delivery window updated',
  [SMSSubjectType.APPOINTMENT_SCHEDULED]: 'Appointment scheduled',
  [SMSSubjectType.DAY_AHEAD_REMINDER]: 'Day ahead reminder',
  [SMSSubjectType.DELAYED_ON_ROUTE]: 'Delayed on route',
  [SMSSubjectType.EMAIL_INVITE]: 'Email invite',
  [SMSSubjectType.FEEDBACK_REQUEST]: 'Feedback request',
  [SMSSubjectType.JOB_COMPLETED]: 'Job completed',
  [SMSSubjectType.JOB_COMPLETED_NO_CHARGE]: 'Job completed no charge',
  [SMSSubjectType.MANUAL_VERIFICATION]: 'Manual verification',
  [SMSSubjectType.MESSAGE_FROM_TECHNICIAN]: 'Message from worker',
  [SMSSubjectType.NEXT_ON_LIST]: 'Next on list',
  [SMSSubjectType.OTHER]: 'Other',
  [SMSSubjectType.PAYMENT_REMINDER]: 'Payment reminder',
  [SMSSubjectType.POWER_OF_ATTORNEY_REQUEST]: 'Power of attorney request',
  [SMSSubjectType.RECALL_PROPOSAL]: 'Recall proposal',
  [SMSSubjectType.RECALL_PROPOSAL_REMINDER]: 'Recall proposal reminder',
  [SMSSubjectType.RESCHEDULED]: 'Rescheduled',
  [SMSSubjectType.RETORQUE_WHEEL_BOLTS_REMINDER]: 'Retorque wheel bolts reminder',
  [SMSSubjectType.TIRE_TREAD_LOWER_LEGAL_LIMIT]: 'Tire tread lower legal limit',
  [SMSSubjectType.UNABLE_TO_COMPLETE]: 'Unable to complete',
  [SMSSubjectType.WHEEL_PICKUP_DOCUMENT_SIGNING_REMINDER]: 'Wheel pickup document signing reminder',
  [SMSSubjectType.WHEEL_PICKUP_NOT_SIGNED_CANCELLED]: 'Wheel pickup not signed cancelled',
  [SMSSubjectType.new_route_assigned]: 'New route assigned',
  [SMSSubjectType.route_not_started_reminder]: 'Route not started reminder',
  [SMSSubjectType.route_confirmation_reminder]: 'Route confirmation reminder',
  [SMSSubjectType.TIRE_QUOTE_LOW_TREAD_MEASUREMENT]: 'Tire quote low tread measurement',
  [SMSSubjectType.TIRE_QUOTE]: 'Tire quote',
  [SMSSubjectType.TIRE_QUOTE_PAID]: 'Tire quote paid',
  [SMSSubjectType.TIRE_QUOTE_ORDERED_AT_SUPPLIER]: 'Tire quote ordered at supplier',
  [SMSSubjectType.TIRE_QUOTE_INVENTORY_RECEIVED_AT_WAREHOUSE_CREATE_BOOKING_FLOW]:
    'Tire quote inventory received at warehouse create booking flow',
  [SMSSubjectType.TIRE_QUOTE_INVENTORY_RECEIVED_AT_WAREHOUSE_TIRE_HOTEL_CHANGE]:
    'Tire quote inventory received at warehouse tire hotel change',
  [SMSSubjectType.TIRES_MOUNTED_ON_WHEELS_AT_STORAGE_FACILITY]: 'Tires mounted on wheels at storage facility',
  [SMSSubjectType.TIRES_RECEIVED_AT_STORAGE_FACILITY_NO_TIRE_HOTEL]: 'Tires received at storage facility no tire hotel',
  [SMSSubjectType.TIRE_QUOTE_TIRE_RECEIVED_AT_STORAGE_FACILITY]: 'Tire quote tire received at storage facility',
  [SMSSubjectType.TIRE_QUOTE_NOT_SELECTED_REMINDER]: 'Tire quote not selected reminder',
  [SMSSubjectType.ad_hoc]: 'Ad hoc'
} as const;
